









import { Component, Vue, Prop } from 'vue-property-decorator'
import { APP_TOPIC_MAP } from '@/apps/open/constants'

@Component({
  componentName: 'ViewInceptMsgAdress'
})
export default class ViewInceptMsgAdress extends Vue {
  @Prop({
    default: {}
  })
  value!: object

  @Prop()
  submit!: Function

  @Prop()
  topic!: string
}
